import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Container, PageHeader } from "@/components/shared";
import PrivacyNote from "@/components/PrivacyNote";
import { FileText, ArrowRight, Trash2 } from "lucide-react";
import { toast } from "sonner";

const KEY_ROUTES = { reply: "/reply", analyze: "/analyze", create: "/create", situation: "/situation", "letters:new": "/courriers" };
const KEY_LABELS = { reply: "Répondre", analyze: "Analyser", create: "Créer du contenu", situation: "Je vis une situation", "letters:new": "Courrier" };

export default function MyWork() {
  const navigate = useNavigate();
  const [drafts, setDrafts] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => api.get("/drafts").then(({ data }) => setDrafts((data.drafts || []).filter((d) => (d.content || "").trim())))
    .catch(() => {}).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const remove = async (key) => {
    try { await api.delete(`/drafts/${encodeURIComponent(key)}`); toast.success("Brouillon supprimé."); load(); }
    catch (_) { toast.error("Suppression impossible."); }
  };

  return (
    <Container className="max-w-2xl">
      <PageHeader title="Mes travaux" subtitle="Retrouvez vos brouillons et reprenez là où vous vous étiez arrêté." />
      <PrivacyNote className="mb-5" />
      {loading ? (
        <p className="text-white/40 text-sm">Chargement…</p>
      ) : drafts.length === 0 ? (
        <div className="card-surface p-6 text-center" data-testid="mywork-empty">
          <FileText size={28} className="mx-auto text-gold mb-2" />
          <p style={{ color: "var(--text-main)" }}>Aucun travail en cours pour l'instant.</p>
          <p className="text-white/50 text-sm mt-1">Vos écrits sont sauvegardés automatiquement pendant que vous travaillez.</p>
        </div>
      ) : (
        <div className="space-y-3" data-testid="mywork-list">
          {drafts.map((d) => (
            <div key={d.key} data-testid={`mywork-item-${d.key}`} className="card-surface p-4 flex items-center gap-3">
              <FileText size={18} className="text-gold shrink-0" />
              <div className="flex-1 min-w-0">
                <p className="font-medium truncate" style={{ color: "var(--text-main)" }}>{KEY_LABELS[d.key] || d.title || d.key}</p>
                <p className="text-white/50 text-xs truncate">{(d.content || "").slice(0, 90)}</p>
              </div>
              {KEY_ROUTES[d.key] && (
                <button onClick={() => navigate(KEY_ROUTES[d.key])} className="text-gold text-sm inline-flex items-center gap-1 shrink-0">
                  Reprendre <ArrowRight size={14} />
                </button>
              )}
              <button onClick={() => remove(d.key)} className="text-white/40 hover:text-white shrink-0" aria-label="Supprimer"><Trash2 size={16} /></button>
            </div>
          ))}
        </div>
      )}
    </Container>
  );
}
